import { useCallback, useMemo, useState } from 'react';

const useFormValidation = (form, getErrorMessage) => {
    const [errors, setErrors] = useState(Object.keys(form).reduce((acc, cur) => ({ ...acc, [cur]: '' }), {}));

    const validate = useCallback(
        (key, value, form) => {
            const errorMessage = getErrorMessage(key, value, form);
            setErrors((errors) => {
                return {
                    ...errors,
                    [key]: errorMessage,
                };
            });
        },
        [getErrorMessage]
    );

    const validateAll = useCallback(() => {
        const nextErrors = Object.fromEntries(
            Object.entries(form).map(([key, value]) => [key, getErrorMessage(key, value, form)])
        );

        setErrors(nextErrors);

        const isValidValueDeep = (value) => {
            if (value == null) return true; // checks null or undefined
            if (typeof value === 'string') return value === '';
            if (Array.isArray(value)) {
                return value.every(isValidValueDeep);
            }
            if (typeof value === 'object') {
                return Object.values(value).every(isValidValueDeep);
            }
            return false;
        };

        return Object.values(nextErrors).every(isValidValueDeep);
    }, [form, getErrorMessage]);

    return useMemo(
        () => ({
            errors,
            validate,
            validateAll,
        }),
        [errors, validate, validateAll]
    );
};

export default useFormValidation;
